export default __webpack_public_path__ + "static/media/cassandra.1aaeb208.svg";